import * as React from 'react';
import * as ObjectPath from 'object-path';
import { hasValue, trimLeadingSpace } from '../../lib/utils';
import './Form.less';

/**
 * @deprecated write functional components instead
 */
export default class Form<P, S extends FormState> extends React.Component<P, S> {
	constructor(props: P) {
		super(props);
		this.handleValueChange = this.handleValueChange.bind(this);
	}

	handleValueChange(name: string, value: unknown, errorMessage: string) {
		// The code has to be exactly this way in order for it to be accessed via 'super' in subclasses.
		handleValueChange.apply(this, [name, value, errorMessage]);
	}

	setField = (name: string) => (value: unknown) => {
		setField(name, value);
	};

	updateFieldsValidation(name: string | number, fieldIsValid: boolean): boolean {
		return updateFieldsValidation.apply(this, [name, fieldIsValid]);
	}
}

export interface FormState {
	isValid?: boolean;
	fieldsValidation?: Record<string, unknown>;
}

// eslint-disable-next-line func-names
export const handleValueChange = function (name: string, value: unknown, errorMessage: string) {
	setField.apply(this, [name, value]);
	updateFieldsValidation.apply(this, [name, !hasValue(errorMessage)]);
};

// TODO This seems to have an issue when binding many inputs concurrently - see CompleteReferenceQuestions. We should
// be using the functional parameter form of .setState to ensure state correctness, and stop relying on returning the
// validity from this.
// eslint-disable-next-line func-names
export const updateFieldsValidation = function (name: string | number, fieldIsValid: boolean): boolean {
	const { fieldsValidation = {} } = this.state;

	if (fieldsValidation[name] !== fieldIsValid) {
		fieldsValidation[name] = fieldIsValid;
		const isValid =
			Object.keys(fieldsValidation)
				.map((key) => fieldsValidation[key])
				.filter((x) => !x).length === 0;
		this.setState({ fieldsValidation, isValid });
		return isValid;
	}
	return this.state.isValid;
};

export const setStateForUpdateValidation = <T extends FormState>(name: string | number, fieldIsValid: boolean) => {
	return (state: T) => {
		const { fieldsValidation = {} } = state;

		if (fieldsValidation[name] !== fieldIsValid) {
			fieldsValidation[name] = fieldIsValid;
			const isValid =
				Object.keys(fieldsValidation)
					.map((key) => fieldsValidation[key])
					.filter((x) => !x).length === 0;
			return { fieldsValidation, isValid };
		}
		return {};
	};
};

// eslint-disable-next-line func-names
const setField = function (name: string, value: unknown) {
	const newState = {};
	if (typeof value === 'string') {
		// eslint-disable-next-line no-param-reassign
		value = trimLeadingSpace(value);
	}
	// Stop Input component effect hook validations from causing an infinite loop.
	if (this.state[name] !== value) {
		// TODO this is potentially preventing setting sub.properties, consider revising this line to enable that
		ObjectPath.set(newState, name, value);
		this.setState(newState);
	}
};
